import { Form, Formik } from "formik";
import * as Yup from "yup";
import CurrencyInput from "../../../Form/CurrencyInput";
import { addLancamentoCaixa } from "../../../../services/api";
import { useContext, useState } from "react";
import { useTranslation } from 'react-i18next';
import { CaixaContext } from "../../../../contexts/caixaContext";
import { AuthContext } from "../../../../contexts/auth";
import { convertPrice } from "../../../../utils/convertPrice";
import { FiMinus, FiCheck } from "react-icons/fi";

import { toast } from "react-toastify";

const SangriaForm = ({ onClose }) => {
  const { t } = useTranslation('cashRegister');

  const validationSchema = Yup.object({
    description: Yup.string().required(t('sangria.validation.descriptionRequired')),
    value: Yup.string().required(t('sangria.validation.valueRequired')),
  });

  const { caixa, refetch } = useContext(CaixaContext);
  const { user } = useContext(AuthContext);

  const [isSenting, setIsSenting] = useState(false);

  const initialValues = { value: "", description: "" };

  const handleSubmit = async (values) => {
    const { value, description } = values;

    try {
      setIsSenting(true);
      await addLancamentoCaixa(
        caixa.id_empresa,
        caixa._id,
        description,
        "Dinheiro",
        -convertPrice(value),
        user._id
      );
      onClose();
      refetch();
    } catch (e) {
      if (e.response?.data?.msg) {
        toast(e.response.data.msg, { type: "error" });
      } else {
        toast(t('sangria.toasts.error'), { type: "error" });
      }
    } finally {
      setIsSenting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, values }) => (
        <Form>
          <div className="sangria-card-unique">
            <div className="sangria-form-header-unique">
              <div className="sangria-icon-unique">
                <FiMinus />
              </div>
              <h3 className="sangria-form-title-unique">{t('sangria.formTitle')}</h3>
            </div>

            <div className="sangria-input-group-unique">
              <label className="sangria-label-unique required">
                {t('sangria.value')}
              </label>
              <CurrencyInput
                className="sangria-input-unique"
                label="value"
                name="value"
                type="text"
                placeholder={t('sangria.placeholder')}
              />
            </div>

            <div className="sangria-input-group-unique">
              <label className="sangria-label-unique required">
                {t('sangria.description')}
              </label>
              <textarea
                className="sangria-input-unique sangria-textarea-unique"
                placeholder={t('sangria.descriptionPlaceholder')}
                id="description"
                name="description"
                value={values.description}
                onChange={handleChange}
              />
              {errors.description && (
                <div className="error-message">{errors.description}</div>
              )}
            </div>
          </div>

          <div className="sangria-actions-unique">
            <button
              className="sangria-btn-unique sangria-btn-cancel-unique"
              type="button"
              onClick={onClose}
              disabled={isSenting}
            >
              {t('sangria.cancel')}
            </button>
            <button
              className="sangria-btn-unique sangria-btn-confirm-unique"
              type="submit"
              disabled={isSenting}
            >
              {isSenting ? (
                <div className="modern-loading-container">
                  <div className="modern-loading-spinner"></div>
                  {t('sangria.processing')}
                </div>
              ) : (
                <>
                  <FiCheck />
                  {t('sangria.confirm')}
                </>
              )}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default SangriaForm;
